'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _http = require('../utils/http');

var _http2 = _interopRequireDefault(_http);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var SECRET_KEY = 'secretKey';
var SITE_KEY = 'siteKey';
exports.default = {
  schema: {
    id: 'recaptcha',
    name: 'reCAPTCHA',
    keys: {
      SITE_KEY: SITE_KEY,
      SECRET_KEY: SECRET_KEY
    },
    requiredKeys: [SITE_KEY, SECRET_KEY],
    spec: [{
      key: SITE_KEY,
      value: ''
    }, {
      key: SECRET_KEY,
      private: true,
      value: ''
    }]
  },
  verify: function verify(response, componentId) {
    return _http2.default.makeCall({
      url: 'https://xg3s7gjqg3.execute-api.us-east-1.amazonaws.com/prod/verifyRecaptcha?componentId=' + componentId,
      data: {
        response: response
      },
      headers: {},
      verb: _http2.default.POST
    });
  }
};